import { Modal, ModalOptions } from '../Modal/modal';

export type PanelOptions = ModalOptions;

export class Panel extends Modal {
  constructor(element: string | HTMLElement, options: PanelOptions = {}) {
    const panelShownEvent = new CustomEvent('panelshown', {
      bubbles: true,
      detail: { el: element },
    });

    const panelHiddenEvent = new CustomEvent('panelhidden', {
      bubbles: true,
      detail: { el: element },
    });

    super(element, {
      triggerOpenAttribute: 'data-panel-open',
      triggerCloseAttribute: 'data-panel-close',
      triggerToggleAttribute: 'data-panel-toggle',
      overlayClass: 'phxsg-panel__overlay',
      containerClass: 'phxsg-panel__body',
      onShown: () => {
        (element instanceof HTMLElement ? element : document.querySelector(element as string))?.dispatchEvent(
          panelShownEvent,
        );
      },
      onHidden: () => {
        (element instanceof HTMLElement ? element : document.querySelector(element as string))?.dispatchEvent(
          panelHiddenEvent,
        );
      },
      ...options,
    });
  }
}
